export const KINESIS_MESSAGES = {
    conferenceDispose: 'conference dispose',
    conferenceJoined: 'conference joined',
    disableParticipantVideo: 'disable participant video',
    liveStream: 'live stream',
    lowerHand: 'lowered hand',
    muteParticipant: 'mute participant',
    pollCreated: 'poll created',
    raiseHand: 'raised hand',
    reaction: 'reaction',
    recording: 'recording',
    screenSharing: 'screen sharing'
};
export const SEND_EVENTS_INTERVAL = 5 * 60 * 1000; // 5 minutes
